import { Box, CircularProgress, Container, Paper } from '@mui/material';
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import LateralMenu from 'components/LateralMenu';
import ErrorBoundary from 'components/ErrorBoundary';
import { ErrorBoundaryContent } from 'components/ErrorBoundary/ErrorBoundary';
import Layout from './Layout';
import TopBar from './TopBar';

function LayoutAuthenticated() {
  const location = useLocation();

  return (
    <Layout.Container>
      <React.Suspense
        fallback={
          <Layout.Content sx={{ alignItems: 'center', justifyContent: 'center' }}>
            <CircularProgress />
          </Layout.Content>
        }
      >
        <TopBar />
        <Layout.Content sx={{ overflow: 'hidden', bgcolor: 'background.default' }}>
          <LateralMenu />
          {/* <Divider orientation="vertical" /> */}
          <Box sx={{ display: 'flex', flex: '1 1 auto' }}>
            <Container sx={{ display: 'flex', marginLeft: '0' }}>
              <Box sx={{ flex: '1 1 auto', px: 4, py: 2, overflow: 'hidden' }}>
                <ErrorBoundary
                  key={location.pathname}
                  reloadChildrenOnTryAgain
                  tryAgainClick={() => {}}
                  fallback={(props) => (
                    <Paper
                      variant="outlined"
                      sx={{
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        flex: '1 1 auto',
                      }}
                    >
                      <ErrorBoundaryContent {...props} />
                    </Paper>
                  )}
                >
                  <Outlet />
                </ErrorBoundary>
              </Box>
            </Container>
          </Box>
        </Layout.Content>
      </React.Suspense>
    </Layout.Container>
  );
}

export default LayoutAuthenticated;
